import React, {useState, useCallback} from 'react';
import Dropdown from 'react-dropdown';

export default function OutputChannelChooser(props) {
    let channelMixer = props.channel.channelMixer;
    const [option, setOption] = useState(getOption(props.channel));

    const onChange = useCallback((value) => {
        channelMixer.switchChannelOutput(
            props.channel.outputNode, 
            value.left,
            value.right);

        props.channel.outputs = [value.left, value.right];

        setOption(getOption(props.channel));
    }, [props.channel, setOption]);

    return (
        <div className="outputs-container">
              <Dropdown
                className='channel-dropdown'
                controlClassName='channel-control-dropdown'
                arrowClassName='channel-arrow-dropdown'
                options={getOptions(channelMixer)}
                onChange={(o) => onChange(o.value)}
                value={option}
                placeholder="Rate" />
        </div>
    );
}

function getOption(channel) {
    let left = channel.outputs[0];
    let right = channel.outputs[1];
    let label = '';
    if (right !== undefined) {
        label =  (left + 1) + '/' + (right + 1);
    } else {
        label = left + 1;
    }
    return {
        label,
        value: {
            left,
            right
        },
    };
}

function getOptions(channelMixer) {
    let options = [];
    for (let i=0; i < channelMixer.channelCount; i+=2) {
        options.push({
            label: (i + 1) + '/' + (i + 2),
            value: {
                left: i,
                right: i + 1,
            }
        });
    }
    for (let i=0; i < channelMixer.channelCount; i++) {
        options.push({
            label: i + 1,
            value: {
                left: i,
            }
        });
    }
    return options;
}
